module.exports = require("@tiptap/extension-highlight");